/**
 * Element fixieren und hinter das vorherige Element legen.
 *
 * Dieses Script setzt ein Margin-bottom in höhe des darüber liegendem Elementes.
 * Sofern es sich nicht um eine Mobiles Endgerät handelt.
 *
 * @param {string} selector - jQuery Selector Element bei dem die höhe berechnet werden soll
 *
 * Events: document.ready, window.resize
 *
 * @return true
 */

function nc_initSpacingMarginBottom(selector) {
    var moduleLogger = LoggerManager.get('spacing-margin-bottom').setPrefix('Selektor: ' + selector);
    moduleLogger.trace('INIT START');
    // Gibt es ein Bild im Selector?
    if ($(selector).find('img').length) {
        // Ja Bild vorhanden
        moduleLogger.info($(selector).find('img').length + 'Bild(er) gefunden');

        // Wenn Bilder geladen wurden
        $(window).load(function () {
            nc_spacingMarginBottom(selector);
        });
        // Script beim Resize ausführen
        $(window).resize(function () {
            nc_spacingMarginBottom(selector);
        });
    } else {
        moduleLogger.info('Kein Bild vorhanden');
        // Kein Bild: Sofort ausführen
        // Lazy Load nicht aktiv
        $(document).ready(function () {
            nc_spacingMarginBottom(selector);
        });
        // Beim Resize Script ausführen
        $(window).resize(function () {
            nc_spacingMarginBottom(selector);
        });
    }
    moduleLogger.trace('INIT ENDE');
}

function nc_spacingMarginBottom(selector) {
    var moduleLogger = LoggerManager.get('spacing-margin-bottom').setPrefix('Selektor: ' + selector);
    moduleLogger.info('SCRIPT START');

    // Variablen für das drüberliegende Elemente erstellen
    var prevSelector = $(selector).prev(),
        prevAllSelector = $(selector).prevAll();
    // Nur ausführen, wenn der Selektor auch größer als die viewport Höhe ist
    moduleLogger.info('Window Höhe: ' + $(window).height() + '; Selektor-Höhe: ' + $(selector).height());
    if ($(window).height() > $(selector).height()) {
        moduleLogger.info('Klassen hinzufügen');
        $(prevSelector).addClass('prev-spacing-margin-bottom');
        $(prevAllSelector).addClass('prev-all-spacing-margin-bottom');
        $(selector).addClass('spacing-margin-bottom');
    } else if ($(selector).hasClass('spacing-margin-bottom')) {
        moduleLogger.info('Klassen entfernen');
        $(prevSelector).removeClass('prev-spacing-margin-bottom');
        $(prevAllSelector).removeClass('prev-all-spacing-margin-bottom');
        $(selector).removeClass('spacing-margin-bottom');
    }
    moduleLogger.info('SCRIPT ENDE');
}